// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__2_UDJ","clinicsSelect":"TableHeading_clinicsSelect__WoCcP"};